export let notificationsDisabledHeaderButton = "jhgKHe";
export let notificationsHeaderButton = "fJ8Y3";
export let notificationsHeaderButtonWithCount = "syZrge";
export let settingsHeaderButton = "QucxFc";
export let myDayHeaderButton = "r9nXUd";
export let premiumHeaderButton = "EeNaHe";
export let manageSubscriptionHeaderButton = "JDC6h";
export let buyMicrosoft365HeaderButton = "trNk2d";
export let upgradeMicrosoft365HeaderButton = "PbEtv";
export let microsoft365UpsellNewOfferAvailable = "eKI3se";
export let rewardsHeaderButton = "Zy7GYc";
export let teamsChatHeaderButton = "r6XSyb";
export let syncHeaderButton = "ilCtud";
export let syncHeaderButtonTooltip = "ph6VOd";
export let undoHeaderButton = "dq$Iic";
export let undoHeaderButtonTooltip = "GWBhIc";
export let updateAvailableHeaderButton = "DZ_AMb";
export let updateAvailableHeaderButtonTooltip = "sBGREd";
export let applyingUpdatesHeaderButton = "jY4CUd";
export let applyingUpdatesHeaderButtonTooltip = "SJ0CYd";
export let teamsChatHeaderButtonWithCount = "eu3b4b";
export default {notificationsDisabledHeaderButton,notificationsHeaderButton,notificationsHeaderButtonWithCount,settingsHeaderButton,myDayHeaderButton,premiumHeaderButton,manageSubscriptionHeaderButton,buyMicrosoft365HeaderButton,upgradeMicrosoft365HeaderButton,microsoft365UpsellNewOfferAvailable,rewardsHeaderButton,teamsChatHeaderButton,syncHeaderButton,syncHeaderButtonTooltip,undoHeaderButton,undoHeaderButtonTooltip,updateAvailableHeaderButton,updateAvailableHeaderButtonTooltip,applyingUpdatesHeaderButton,applyingUpdatesHeaderButtonTooltip,teamsChatHeaderButtonWithCount};